/** In-session copies of uploaded files for preview before/without a download API. */
const filesByDocId = new Map<string, File>();

export function setCriminalPreviewFile(docId: string, file: File): void {
  filesByDocId.set(docId, file);
}

export function getCriminalPreviewFile(docId: string): File | undefined {
  return filesByDocId.get(docId);
}

export function clearCriminalPreviewFile(docId: string): void {
  filesByDocId.delete(docId);
}
